import Table, {
  Column,
  DEFAULT_TABLE_HEADER_HEIGHT,
  SIMPLE_TABLE_HEADER_HEIGHT,
} from './Table';

export default Table;

export { Column, SIMPLE_TABLE_HEADER_HEIGHT, DEFAULT_TABLE_HEADER_HEIGHT };
